/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Table_ProviderInputs */

const en_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const zh_hans1_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务商`)
};

const pt_br2_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedor`)
};

const es_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

const fr_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur`)
};

const de_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

const ru_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик`)
};

const it_platform_table_provider = /** @type {(inputs: Platform_Table_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Platform_Table_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_table_provider = /** @type {((inputs?: Platform_Table_ProviderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Table_ProviderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_table_provider(inputs)
	if (locale === "pt-BR") return pt_br2_platform_table_provider(inputs)
	if (locale === "es") return es_platform_table_provider(inputs)
	if (locale === "fr") return fr_platform_table_provider(inputs)
	if (locale === "de") return de_platform_table_provider(inputs)
	if (locale === "ru") return ru_platform_table_provider(inputs)
	if (locale === "it") return it_platform_table_provider(inputs)
	return en_platform_table_provider(inputs)
});